const numbersStyle = (theme) => ({
	noNumbers: {
		marginTop: '200px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'column',
		'& > div': {
			marginBottom: '60px',
		},
		[theme.breakpoints.down('sm')]: {
			marginTop: '120px',
		},
	},
	numbersWrapper: {
		marginTop: '24px',
	},
});

export default numbersStyle;
